// ============================================
// EXP-UBICACION — catalogo + helper de ubicacion del proyecto
// ============================================
// Para expedientes cuyo cliente NO tiene sucursal (persona fisica: casa, depto,
// oficina). Compartido entre la lista (Expedientes.js), el modal de creacion y
// el de edicion (ModalEditarExpediente.js) para evitar duplicar el catalogo.

export const TIPOS_UBICACION = [
  { value: 'departamento', label: 'Departamento' },
  { value: 'casa',         label: 'Casa' },
  { value: 'oficina',      label: 'Oficina' },
  { value: 'local',        label: 'Local' },
  { value: 'bodega',       label: 'Bodega' },
  { value: 'otro',         label: 'Otro' },
];

const LABEL_TIPO_UBICACION = TIPOS_UBICACION.reduce((m, t) => { m[t.value] = t.label; return m; }, {});

// "Departamento (Condesa)" | "Departamento" | null (si no hay tipo ni especificacion).
export function textoUbicacionLibre(exp) {
  const tipo = exp && exp.tipo_ubicacion;
  const espec = exp && exp.ubicacion_especificacion && String(exp.ubicacion_especificacion).trim();
  if (!tipo && !espec) return null;
  const lbl = LABEL_TIPO_UBICACION[tipo] || (tipo ? tipo : null);
  if (lbl && espec) return `${lbl} (${espec})`;
  return lbl || espec;
}
